import React from 'react';
import { observer } from 'mobx-react-lite';
import ChatMessages from '@/comp/Chatbot/ChatMessages';
import ChatInput from '@/comp/Chatbot/ChatInput';
import { useStores } from '@/hooks/use-stores';
import { SuggestedPromptsContainer, SuggestedPromptButton } from '@/comp/Chatbot/ChatInput.styles';
import * as S from './ChatConversation.styles';

interface ChatConversationProps {
  onSend: (message: string) => void;
  onPromptClick: (prompt: string) => void;
  onPublishClick?: (insightId: string) => void;
}

const ChatConversation: React.FC<ChatConversationProps> = observer(({ onSend, onPromptClick, onPublishClick }) => {
  const { chatbotStore } = useStores();

  const handleResendMessage = () => {
    chatbotStore.resendLastMessage();
  };

  return (
    <S.ConversationWrapper>
      <ChatMessages
        messages={chatbotStore.currentMessages}
        suggestedPrompts={chatbotStore.suggestedPrompts}
        onPromptClick={onPromptClick}
        onPublishClick={onPublishClick}
        disabled={chatbotStore.isLoading || chatbotStore.isStreaming}
        onResendMessage={handleResendMessage}
        renderInput={
          chatbotStore.currentMessages.length === 0
            ? () => (
                <ChatInput
                  onSend={onSend}
                  isLoading={chatbotStore.isLoading}
                  isStreaming={chatbotStore.isStreaming}
                  isEmpty={true}
                  disabled={false}
                />
              )
            : undefined
        }
      />
      {chatbotStore.currentMessages.length > 0 && (
        <>
          {/* Show suggested prompts above input - always visible when there are messages */}
          {chatbotStore.suggestedPrompts && chatbotStore.suggestedPrompts.length > 0 && (
            <SuggestedPromptsContainer>
              {chatbotStore.suggestedPrompts.map(prompt => (
                <SuggestedPromptButton
                  key={prompt.id}
                  onClick={() =>
                    !(chatbotStore.isLoading || chatbotStore.isStreaming) && onPromptClick?.(prompt.prompt)
                  }
                  disabled={chatbotStore.isLoading || chatbotStore.isStreaming}
                >
                  {prompt.badge && <span className="badge">{prompt.badge}</span>}
                  {prompt.label}
                </SuggestedPromptButton>
              ))}
            </SuggestedPromptsContainer>
          )}
          <ChatInput
            onSend={onSend}
            isLoading={chatbotStore.isLoading}
            isStreaming={chatbotStore.isStreaming}
            isEmpty={false}
            disabled={false}
          />
        </>
      )}
    </S.ConversationWrapper>
  );
});

ChatConversation.displayName = 'ChatConversation';

export default ChatConversation;
